<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :newCreateButtonLabel="newCreateButtonLabel"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    modelNameSingular: String,
    newCreateButtonLabel: {
      type: String,
      default: function() {
        return "Adicionar " + this.modelNameSingular
      }
    },
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_NEW_PURCHASE_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.accountContext.purchase;
          this.extraData = response.data;
          // this.extraData.activeTab = 0;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    createServerEntry: function(purchase) {
      // console.log("PURCHASE", purchase, purchase.validations, this.deepFilterEntryWithAllowedFieldsForMutation(purchase, purchase.validations));
      // console.log("purchase", purchase);
      this.pageLoading = true;
      console.log("purchase", purchase);
      var filtered = this.deepFilterEntryWithAllowedFieldsForMutation(purchase, purchase.validations);
      console.log("filtered", filtered);
      this.$apollo
        .mutate({
          mutation: CREATE_PURCHASE_MUTATION,
          variables: {
            input: filtered
          }
        })
        .then(response => {
          // console.log(response);
          var errors = response.data.createPurchase.errors

          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created");
            this.resetForm();
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      // this.extraData.activeTab = 0;
      // console.log("extra tab = ", this.extraData.activeTab);
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_PURCHASE_QUERY = gql `
  {
    accountContext {
      purchase {
        id
        code
        billDate
        series
        number
        estimatedDeliveryDate
        nfeXml
        orderValidity
        supplierId
        totalPrice
        validations
        totalCarriageValue
        totalDiscountValue
        totalInsuranceValue
        otherExpensesTotalValue
        observation
        dummyEntryMovementItemsAttributes {
          id
          price
          quantity
          hasLot
          enabledLots
          itemId
          item {
            id
            name
            description
            unit {
              name
            }
          }
          dummyEntryMovementItemLotsAttributes{
            dueDate
            manufacturingDate
            lotNumber
            quantity
            packagingQuantity
          }
          packagingId
          packaging {
            id
            name
            unitName
          }
          storageId
          storage {
            id
            name
            location
          }
          validations
        }
        paymentsAttributes {
          id
          code
          bankAccountId
          paymentMethodId
          value
          initialDate
          installmentsInterval {
            id
          }
          paymentConditionId
          paymentCondition {
            id
            description
            numberOfInstallments
          }
          paymentMethod {
            id
            name
          }
          bankAccount {
            id
            name
          }
          installmentsAttributes {
            id
            value
            originalValue
            customCode
            dueDate
            code
            status
            statusKey
            statusColor
            paidAmount
            paymentDate
            bankAccount {
              id
              name
            }
          }
        }
      }
      allSuppliers {
        id
        name
      }
      allCollaborators{
        id
        name
      }
      allPurchaseCfops{
        id
        text
      }
    }
    globalContext {
			allPaymentConditions {
        id
        description
        numberOfInstallments
      }
      allStates {
        id
        shortName
      }
    }
  }
`;

const CREATE_PURCHASE_MUTATION = gql `
  mutation($input: PurchaseCreateInputObject!) {
    createPurchase(input: $input) {
      cashFlow {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
